import React from 'react';
import './SearchPage.css'
import {useStateValue } from '../StateProvider.js'
import UseGoogleSearch from '../useGoogleSearch.js';
import SearchIcon from '@mui/icons-material/Search';
import Response from "../response.js"
import { Link } from 'react-router-dom';
import Search from "../components/Search.js"
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Footer from '../components/Footer';
import SettingsIcon from '@mui/icons-material/Settings';
import GridOnIcon from '@mui/icons-material/GridOn';
import { Avatar, IconButton } from '@mui/material';



function SearchPage() {
    // const [{term}, dispatch] =useStateValue();
    
    
    const term= JSON.parse(localStorage.getItem('seachTerm'));
    const { data } = UseGoogleSearch(term)
    //const data = Response;
    console.log(data)
    


    return (
        <div className='search__page'>
            <div className='search__page--header'>
                <div className='searchBar__options'>
                    <div className='search__top'>  
                        <Link to="/">
                            <div className='search__page--logo-wrapper'>
                                <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"
                                className='search__page--logo' alt=""/> 
                            </div>
                        </Link> 
                        <div className='searchPage__input'>
                            <Search hideButtons />
                        </div>
                    </div> 
                    <div className='rightSide__options'>
                    <SettingsIcon className='rightSide__option'/>
                    <GridOnIcon className='rightSide__option'/>
                    <Avatar className='rightSide__option'/>
                    </div>
                </div>

              <div className='search__page--header-body'>
                
                <div className='search__page--options'>
                    <div className='search__page--options-left'>
                        <div className='search__page--option'>
                            <SearchIcon />
                            <Link to= "/all">All</Link>
                        </div>
                        <div className='search__page--option'>
                            <DescriptionIcon />
                            <Link to= "/news">News</Link>
                        </div>
                        <div className='search__page--option'>
                            <ImageIcon />
                            <Link to= "/images">Images</Link>
                        </div>
                        <div className='search__page--option'>
                            <LocalOfferIcon />
                            <Link to= "/shopping">Shopping</Link>
                        </div>
                        <div className='search__page--option'>
                            <LocationOnIcon />
                            <Link to= "/maps">Maps</Link>
                        </div>
                        <div className='search__page--option'>
                            <MoreVertIcon />
                            <Link to= "/more">More</Link>
                        </div>

                    </div>
                    <div className='search__page--options-right'>
                    <div className='search__page--option'>
                        <Link to="/settings">Settings</Link>
                    </div>
                    <div className='search__page--option'>
                        <Link to="/tools">Tools</Link>
                    </div>
                    </div>
                </div>
              </div>
            </div>
            {term && <>
            <div className='search__page--results'>
                <p className='search__page--result-count'>
                    About {data?.searchInformation.formattedTotalResults} results {data?.searchInformation.formattedSearchTime} seconds for {term}
                </p>
                {data? data.items.map(item =>(
                    <div className='search__page--result'>
                       {/* <a href={item.link}>
                       {item.pagemap?.cse_image?.
                       length > 0 && item.pagemap?.
                       cse_image[0].src && (<img alt="" className='search__page--result-img' 
                        src={item.pagemap?.cse_image[0]?.src}
                        /> )}
                       
                        </a>  */}
                        
                        <p className="search__page--result-snippet">
                        {item.displayLink}
                        <a className='search__page--result-title' href={item.link}>
                            <h2>{item.title}</h2>
                            
                        </a>
                            {item.snippet}
                        </p>
                    </div>
                )):new Array(10).fill(0).map((_, index) => (
                    <><div className="search__result--skeleton" key={index}>
                    <div className="search__page--result-title">
                    <div className="search__title--skeleton"></div>
                    <div className="search__website--skeleton"></div>
                    </div>
                    <div className="search__page--result-snippet">
                    <p className="search__body--skeleton"></p> 
                    </div>
                </div></>
                 ))}
            </div></>
            }
            <Footer/>
        </div>
    );
}

export default SearchPage;
